import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useNavigate, useParams } from 'react-router-dom';
import MapComponent from '../components/map/MapComponent';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LanguageIcon from '@mui/icons-material/Language';
import Link from '@mui/material/Link';
import { obtenerDatosHotel } from '../services/motorService';
import Cookies from 'js-cookie';
import Banner from '../components/banner/Banner';
import { useLocation } from 'react-router-dom';

export default function Contact() {
  const [datosHotel, setDatosHotel] = useState(null);
  //const { hotCod } = useParams(); // Obtener hotCod desde la URL
  const navigate = useNavigate(); // Hook para navegación
  //const hotCod = Cookies.get('hotCod');
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const hotcodParam = params.get('hotcod');
    const hotCod = hotcodParam ?? Cookies.get('hotCod') ?? null;
  useEffect(() => {
    const getData = async () => {
      try {
        const data = await obtenerDatosHotel(hotCod); // Usa hotCod en la llamada a la API
        console.log("a ver la data:", data);
        if (data && data.MotorHotAdmintour != 0) {
          if (data.MotorHotWpp) { // Asegúrate de que data.MotorHotWpp existe
            const cleanPhoneNumber = data.MotorHotWpp.replace(/\D/g, ''); // Elimina cualquier carácter no numérico
            data.MotorHotWpp = cleanPhoneNumber; // Asigna el número limpio de nuevo a data
          }
          setDatosHotel(data);
        } else {
          navigate('/error'); // Redirige a la página de error si no hay datos
        }

      } catch (error) {
        console.error('Error fetching hotel data:', error);
        navigate('/error'); // Redirige a la página de error en caso de error
      }
    };
    getData();
  }, [hotCod, navigate]); // Ejecutar efecto cuando hotCod o navigate cambie

  if (!datosHotel) {
    return null; // Retorna null mientras se obtienen los datos o si no se encuentran
  }

  const socialNetworks = [
    {
      name: "Instagram",
      nameMotor: "MotorHotInstagram",
      url: datosHotel.MotorHotInstagram,
      icon: <InstagramIcon fontSize="large" />
    },
    {
      name: "Facebook",
      nameMotor: "MotorHotFacebook",
      url: datosHotel.MotorHotFacebook,
      icon: <FacebookIcon fontSize="large" />
    },
    {
      name: "WhatsApp",
      nameMotor: "MotorHotWhatsApp",
      url: `https://wa.me/${datosHotel.MotorHotWpp}?text=Hola%2C%20me%20gustaría%20obtener%20más%20información%20sobre%20sus%20servicios.`,
      icon: <WhatsAppIcon fontSize="large" />
    },
    {
      name: "Web",
      nameMotor: "MotorHotWeb",
      url: datosHotel.MotorHotWeb,
      icon: <LanguageIcon fontSize="large" />
    }
  ];

  const linkCorreo = `mailto:${datosHotel.MotorHotCorreo?.trim()}?subject=Consulta&body=Hola%2C%20me%20gustaría%20obtener%20más%20información%20sobre%20sus%20servicios.`;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ width: '100vw', position: 'relative', left: '50%', right: '50%', marginLeft: '-50vw', marginRight: '-50vw', overflowX: 'hidden', mt: 2 }}>
      <Banner />
      </Box>
      <Typography variant="h5" component="div" sx={{ mb: 2 }}>
        Contacto
      </Typography>

      <Card sx={{ minWidth: 275 }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography sx={{ fontSize: 20 }} color="text.primary" gutterBottom>
            Correo electrónico
          </Typography>
          <Link href={linkCorreo} underline="hover">
            {datosHotel.MotorHotCorreo}
          </Link>
          <Typography sx={{ fontSize: 20 }} color="text.primary" gutterBottom>
            Teléfono
          </Typography>
          <Typography sx={{ fontSize: 16 }} color="text.secondary" component="div">
            {datosHotel.MotorHotTelefono} - {datosHotel.MotorHotHorario}
          </Typography>
        </CardContent>
      </Card>
      <Card sx={{ minWidth: 275 }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography sx={{ fontSize: 20 }} color="text.primary" gutterBottom>
            Redes sociales
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {socialNetworks.map((red, index) => (
              red.url && (
                <IconButton key={index} component="a" href={red.url} target="_blank" aria-label={red.name}>
                  {red.icon}
                </IconButton>
              )
            ))}
          </Box>
        </CardContent>
      </Card>
      <Card sx={{ minWidth: 275 }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography sx={{ fontSize: 20 }} color="text.primary" gutterBottom>
            Dirección
          </Typography>
          <Typography sx={{ fontSize: 16 }} color="text.secondary" component="div">
            {datosHotel.MotorHotDireccion}
          </Typography>
          <Typography sx={{ fontSize: 20 }} color="text.primary" gutterBottom>
            Indicaciones
          </Typography>
          <Typography
            variant="body2"
            component="div"
            color="text.secondary"
            sx={{ fontSize: 16, whiteSpace: "pre-line" }}
          >
            {datosHotel.MotorHotIndicaciones}
          </Typography>
        </CardContent>
      </Card>
      <Card sx={{ minWidth: 275 }}>
        <CardContent>
          <MapComponent />
        </CardContent>
      </Card>
    </Box>
  );
}